import React, { useState, useEffect } from 'react';
import { UserOutlined } from '@ant-design/icons';
import { resolveAvatarSrc } from '../../utils/avatarUtils';
import { translateRoleName } from '../../utils/formHelpers';

const HeaderUserProfile = ({ user, isConnected, isDarkMode }) => {
  const [imageError, setImageError] = useState(false);
  const avatarSrc = resolveAvatarSrc(user?.image_url);

  // در صورت تغییر تصویر کاربر، وضعیت خطا ریست می‌شود
  useEffect(() => {
    setImageError(false);
  }, [user?.image_url]);

  if (!user) return null;

  const hasValidImage = Boolean(avatarSrc && !imageError);
  const specificRole = user.roles?.find((r) => r.name !== 'employee' && r.name !== 'client') || user.roles?.[0];
  const roleName = specificRole?.display_name || specificRole?.name;
  const translatedRole = roleName ? translateRoleName(roleName) : null;
  const tooltipText = `${user.name || 'کاربر'}${translatedRole ? ` (${translatedRole})` : ''}`;

  return (
    <div
      className={`
        flex items-center gap-1.5 sm:gap-2 px-2 sm:px-2.5 md:px-3 py-1.5 rounded-lg cursor-default
        transition-all duration-200 select-none flex-shrink-0 leading-normal
        ${isDarkMode 
          ? 'bg-[rgba(13,136,126,0.08)] hover:bg-[rgba(13,136,126,0.14)] border border-[rgba(13,136,126,0.22)]' 
          : 'bg-gray-50 hover:bg-gray-100 border border-gray-200'
        }
      `}
      title={tooltipText}
    >
      {/* کانتینر آواتار با ابعاد دقیق ۳۶ پیکسل */}
      <div
        className="relative flex-shrink-0"
        style={{ width: '36px', height: '36px', minWidth: '36px', minHeight: '36px' }}
      >
        {hasValidImage ? (
          <img
            src={avatarSrc}
            alt={user.name || 'کاربر'}
            onError={() => setImageError(true)}
            className={`w-9 h-9 rounded-full object-cover ring-2 ${
              isDarkMode ? 'ring-[rgba(13,136,126,0.35)]' : 'ring-blue-500/20'
            }`}
            style={{
              width: '36px',
              height: '36px',
              borderRadius: '50%',
              objectFit: 'cover',
              display: 'block',
            }}
          />
        ) : (
          <div
            className={`w-9 h-9 rounded-full flex items-center justify-center ring-2 ${
              isDarkMode
                ? 'bg-[rgba(13,136,126,0.2)] text-brand-primary ring-[rgba(13,136,126,0.35)]'
                : 'bg-blue-100 text-blue-600 ring-blue-500/20'
            }`}
            style={{
              width: '36px',
              height: '36px',
              borderRadius: '50%',
              display: 'flex',
            }}
          >
            <UserOutlined className="text-base leading-none" />
          </div>
        )}

        {/* دایره وضعیت اتصال سوکت روی گوشه آواتار کاربر با z-index بالا و شفافیت ۱۰۰٪ کامل */}
        <span
          className={`
            absolute -bottom-0.5 -right-0.5 w-3 h-3 rounded-full opacity-100 flex-shrink-0
            ${isConnected ? 'bg-[#22c55e]' : 'bg-[#ef4444]'}
          `}
          style={{
            position: 'absolute',
            bottom: '-2px',
            right: '-2px',
            width: '12px',
            height: '12px',
            borderRadius: '50%',
            backgroundColor: isConnected ? '#22c55e' : '#ef4444',
            border: isDarkMode ? '2px solid #0f172a' : '2px solid #ffffff',
            opacity: 1,
            zIndex: 30,
            display: 'block',
            boxShadow: isDarkMode
              ? '0 0 0 1px rgba(255,255,255,0.08), 0 1px 3px rgba(0,0,0,0.5)'
              : '0 0 0 1px rgba(0,0,0,0.05), 0 1px 3px rgba(0,0,0,0.15)',
          }}
          aria-hidden
        />
      </div>

      {/* اطلاعات متنی کاربر (نام و نقش) */}
      <div className="hidden sm:flex flex-col items-start min-w-0 leading-tight">
        <span 
          className={`text-xs sm:text-sm font-semibold truncate max-w-[85px] md:max-w-[120px] lg:max-w-[160px] ${
            isDarkMode ? 'text-white' : 'text-gray-800'
          }`}
          style={{ fontFamily: 'CustomFont' }}
        >
          {user.name || 'کاربر'}
        </span>
        {translatedRole && (
          <span 
            className={`hidden md:inline text-[11px] sm:text-xs truncate max-w-[85px] md:max-w-[120px] lg:max-w-[160px] ${
              isDarkMode ? 'text-white/65' : 'text-gray-500'
            }`}
            style={{ fontFamily: 'CustomFont' }}
          >
            {translatedRole}
          </span>
        )}
      </div>
    </div>
  );
};

export default HeaderUserProfile;
